export enum Preferences {
  MusicPlayback = 'musicPlayback',
  SoundEffects = 'soundEffects',
  HintsEffects = 'trainingHints',
  BadgeNotifications = 'badgeNotifications',
  FontSize = 'fontSize',
  HighContrast = 'highContrast',
  ColorTheme = 'colorTheme',
  EssayAIPaste = 'essayAIPaste'
}
